import './App.css';
import router from './Router';
import { RouterProvider } from 'react-router-dom';
import { toastConfig } from 'react-simple-toasts';
import 'react-simple-toasts/dist/theme/success.css';
import api from './utils/axios';

// specify the theme in toastConfig
toastConfig({
	theme: 'success',
});

const apiTabClosedEvent = () => {
	api.onTabClosed();
};

window.addEventListener('unload', apiTabClosedEvent);

function App() {
	return (
		<div className="App">
			<RouterProvider router={router} />
		</div>
	);
}

export default App;
